(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPersonaController', SSPersonaController);

    SSPersonaController.$inject = ['SSPersona'];

    function SSPersonaController(SSPersona) {

        var vm = this;

        vm.sSPersonas = [];

        loadAll();

        function loadAll() {
            SSPersona.query(function(result) {
                vm.sSPersonas = result;
                vm.searchQuery = null;
            });
        }
    }
})();
